import React from 'react';

type Props = {

    className?  : string
    style?      : any

    icon?       : string
    label?      : string

    disabled?   : boolean

    value?      : any
    palette     : 'project' | 'gray'
    size        : '26' | '22'

    onClick     : callback
    onDelete    : callback

    children?   : any

    color?      : number

    // Special cases
    // priority?   : number        // if passes - display icon & label automatically
    // statusId?   : ID            // if passes - display label & color
}

export default function Pill(props: Props) {

    // const onClick = (e:React.SyntheticEvent) => {
    //     e.stopPropagation()
    //     // console.log("on click", props.value)
    //     if (props.onClick) props.onClick(props.value)
    // }

    const onDelete = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        // console.log("on delete", props.value)
        if (props.onDelete) props.onDelete(props.value)
    }


    let bgClass : string | false        = false
    let borderClass :string | false    = false

    switch (props.palette) {
        case 'project':
            const color         = _.get(props, 'color', false)
            bgClass     = "gd-c-bgp-"+color + ' pale'
            borderClass = "gd-c-pale-border-"+ color
            break
        case 'gray':
            bgClass     = 'gray'
            break
    }

    const classes = Classes('ui5-pill-u',
        's-'+props.size,
        bgClass,
        borderClass,
        props.className
    );

    return (
        <div className={classes} style={props.style} onClick={props.onClick}>
            {props.children}
            {props.icon && <div className={Classes("icon", props.icon)} />}
            {props.label}
            {!!props.onDelete && !props.disabled && <div className="i5-close" onClick={onDelete} />}
        </div>
    )

}

Pill.defaultProps = {
    size        : '26',
    palette     : 'gray'
}
